import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './invoicing.scss'

// Constants
import { DracarJobFeeSettingType, DepartmentType } from '../../../constants'

// Actions
import { getInvoicingInformation, saveInvoicingInformation, getDracarStores, saveDracarStores, getAccountingSystemField, deleteAccountingSystemField, updateAccountingSystemField } from '../../../actions/settings'
import { getAuthResources } from '../../../actions/auth'

// Elements
import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Radio from '../../../shared/elements/radio'
import Switch from '../../../shared/elements/switch'
import Text from '../../../shared/elements/text'
import Grid from '../../../shared/elements/grid'
import Null from '../../../shared/elements/null'
import AddButton from '../../../shared/elements/addButton'
import RemoveButton from '../../../shared/elements/removeButton'
import Label from '../../../shared/elements/label'
import DropDown from '../../../shared/elements/dropDown'

// Components
import Confirm from '../../../shared/components/Confirm'
import Portal from '../../../shared/components/Portal'
import ProductNumbers from './ProductNumbers'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'
import Inline from '../../../shared/elements/inline'

const DICT_HANDLED_IN_APROMAS = 17868
const DICT_HANDLED_IN_DRACAR = 17869
const DICT_HANDLED_IN_AUTOLINE = 18142

class Invoicing extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Invoicing: {
        ShopId: 0,
        IsPaintshop: false,
        TransferWorkHoursAsUnitPrice: false,
        AccountingSystem: 0,
        EconomicDepartment: 0,
        EconomicDepartmentType: 0,
        VismaNetDepartment: 0,
        VismaNetDepartmentType: 0,
        HeliosTransferLWTIdCode: false,
        HeliosNumber: '',
        EconomicId: '',
        EconomicUserName: '',
        EconomicPassword: '',
        EconomicWebHook: '',
        EconomicToken: '',
        EconomicAuthUrl: '',
// new Visma.net
        VismaNetToken: '',
        VismaNetAuthUrl: '',

        C5Ftp: '',
        TFSOUserName: '',
        TFSOPassword: '',
        TFSODepartmentNumber: null,
        DracarInvoiceLaborTotal: false,
        DracarInvoiceUnitsTotal: false,
        DracarInvoiceLaborTotalCode: null,
        UseDracarSparePartCreation: false,
        InsuranceCompanyTypeInDracar: 0,
        DracarJobFeeSettings: []
      },
      DracarStores: {
        ShopId: 0,
        DracarCompanyStores: []
      },
      DracarStoreNew: {
        StoreName: '',
        StoreId: '',
        EnterpriseId: '',
        IsDeleted: false
      },
      Confirm: {
        deleteKey: 0,
        Show: false
      },
      PNumberAccountingSystem: 0,
      SelectedHeadlineField: -1,
      SelectedText1Field: -1,
      SelectedText2Field: -1,
      SelectedOtherReferencesField: -1,
      SelectedReferenceField: -1,
      SelectedInvoiceTextField: -1,
      SelectedCustomerOrderIdField: -1,
      SelectedExternalReferenceField: -1,
      SelectedExtraLinesField: -1,
      SelectedCommentField: -1,
      HeadlineFields: [],
      Text1Fields: [],
      Text2Fields: [],
      OtherReferencesFields: [],
      ReferenceFields: [],
      InvoiceTextFields: [],
      CustomerOrderIdFields: [],
      ExternalReferenceFields: [],
      ExtraLinesFields: [],
      CommentFields: []
    }
    this.onChange = this.onChange.bind(this)
    this.onAccountingSystemChange = this.onAccountingSystemChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.allFieldsFilledIn = this.allFieldsFilledIn.bind(this)
    this.confirmDelete = this.confirmDelete.bind(this)
    this.notConfirm = this.notConfirm.bind(this)
    this.getAccountingSystemName = this.getAccountingSystemName.bind(this)
    this.onFieldChange = this.onFieldChange.bind(this)
  }

  componentDidMount () {
    this.getInvoicingInformation()
    this.getDracarStores()
    this.getAccountingSystemField()
  }

  getInvoicingInformation () {
    this.props.getInvoicingInformation(this.props.auth.user.ShopId).then((res) => {
      this.setState({
        Invoicing: {
          ShopId: res.data.ShopId,
          IsPaintshop: res.data.IsPaintshop,
          AccountingSystem: res.data.AccountingSystem,
          EconomicDepartment: res.data.EconomicDepartment,
          EconomicDepartmentType: res.data.EconomicDepartmentType,
          TransferWorkHoursAsUnitPrice: res.data.TransferWorkHoursAsUnitPrice,
          // Visma.net
          VismaNetDepartment: res.data.VismaNetDepartment,
          VismaNetDepartmentType: res.data.VismaNetDepartmentType,
          HeliosNumber: res.data.HeliosNumber,
          EconomicId: res.data.EconomicId,
          EconomicUserName: res.data.EconomicUserName,
          EconomicPassword: res.data.EconomicPassword,
          EconomicWebHook: res.data.EconomicWebHook,
          EconomicToken: res.data.EconomicToken,
          EconomicAuthUrl: res.data.EconomicAuthUrl,
          // Visma.net
          VismaNetToken: res.data.VismaNetToken,
          VismaNetAuthUrl: res.data.VismaNetAuthUrl,

          C5Ftp: res.data.C5Ftp,
          DracarJobFeeSettings: res.data.DracarJobFeeSettings,
          DracarInvoiceLaborTotal: res.data.DracarInvoiceLaborTotal,
          DracarInvoiceLaborTotalCode: res.data.DracarInvoiceLaborTotalCode,
          DracarInvoiceUnitsTotal: res.data.DracarInvoiceUnitsTotal,
          UseDracarSparePartCreation: res.data.UseDracarSparePartCreation,
          InsuranceCompanyTypeInDracar: res.data.InsuranceCompanyTypeInDracar,
          TFSOUserName: res.data.TFSOUserName,
          TFSOPassword: res.data.TFSOPassword,
          TFSODepartmentNumber: res.data.TFSODepartmentNumber
        },
        PNumberAccountingSystem: res.data.AccountingSystem
      })
    }, (err) => {
      console.log(err)
    })
  }

  getDracarStores () {
    this.props.getDracarStores(this.props.auth.user.ShopId).then(res => {
      this.setState({
        DracarStores: {
          ShopId: res.data.ShopId,
          DracarCompanyStores: res.data.DracarCompanyStores
        }
      })
    }, (err) => {
      console.log(err)
    })
  }

  getAccountingSystemField () {
    const positions = [
      {
        'id': 0,
        'key': 'HeadlineFields'
      },
      {
        'id': 1,
        'key': 'Text1Fields'
      },
      {
        'id': 2,
        'key': 'Text2Fields'
      },
      {
        'id': 3,
        'key': 'OtherReferencesFields'
      },
      {
        'id': 4,
        'key': 'ReferenceFields'
      },
      {
        'id': 5,
        'key': 'InvoiceTextFields'
      },
      {
        'id': 6,
        'key': 'CustomerOrderIdFields'
      },
      {
        'id': 7,
        'key': 'ExternalReferenceFields'
      },
      {
        'id': 8,
        'key': 'ExtraLinesFields'
      },
      {
        'id': 9,
        'key': 'CommentFields'
      }
    ]

    positions.forEach(position => {
      this.setState({[position.key]: []})
    })

    this.props.getAccountingSystemField().then(res => {
      res.data.forEach(element => {
        let key = positions[element.Position].key
        this.setState({[key]: [...this.state[key], element]})
      })
    }, (err) => {
      console.log(err)
    })
  }

  allFieldsFilledIn (fields) {
    const { Invoicing } = this.state
    let filledIn = true

    if (Array.isArray(fields)) {
      fields.forEach(field => {
        const storeField = Invoicing[field]

        if (storeField) {
          switch ((typeof storeField).toLocaleLowerCase()) {
            case 'string':
              if (storeField.replace(/\s/g, '').length === 0) {
                filledIn = false
              }
              break
            default:
              break
          }
        } else {
          filledIn = false
        }
      })
    } else {
      filledIn = false
    }

    return filledIn
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    if (e.target.type === 'radio' || e.target.type === 'checkbox') {
      let typesToConvert = [ 'AccountingSystem', 'EconomicDepartment', 'VismaNetDepartment', 'InsuranceCompanyTypeInDracar' ]
      if (e.target.type === 'checkbox') {
        value = e.target.checked
      } else if (typesToConvert.includes(e.target.name)) {
        value = parseInt(value)
      } else {
        value = (e.target.value === 'yes')
      }

      if (e.target.name === 'EconomicUseCustomDepartment') {
        value = e.target.checked ? -1 : 0
        this.setState({
          Invoicing: {
            ...this.state.Invoicing,
            EconomicDepartment: value
          }
        }, () => {
          this.onBlur(e)
        })
      } else if (e.target.name === 'VismaNetUseCustomDepartment') {
        value = e.target.checked ? -1 : 0
        this.setState({
          Invoicing: {
            ...this.state.Invoicing,
            VismaNetDepartment: value
          }
        }, () => {
          this.onBlur(e)
        })
      } else {
        this.setState({
          Invoicing: {
            ...this.state.Invoicing,
            [e.target.name]: value
          }
        }, () => {
          this.onBlur(e)
        })
      }
    } else {
      if (e.target.name.startsWith('DType')) {
        let name = e.target.name.substring(5)
        let index = this.state.Invoicing.DracarJobFeeSettings.findIndex(x => x.DType === parseInt(name))
        let fees = this.state.Invoicing.DracarJobFeeSettings
        fees[index].DNumber = value
        this.setState({
          Invoicing: {
            ...this.state.Invoicing,
            DracarJobFeeSettings: fees
          }
        })
      } else if (e.target.name.startsWith('DracarStore')) {
        let name = e.target.name.substring(11)
        this.setState({
          DracarStoreNew: {
            ...this.state.DracarStoreNew,
            [name]: e.target.value
          }
        })
      } else {
        if (e.target.name === 'TFSODepartmentNumber') {
          value = value.trim()
          value = (value.length > 0) ? parseInt(value) : null
        }
        this.setState({
          Invoicing: {
            ...this.state.Invoicing,
            [e.target.name]: value
          }
        })
      }
    }
  }

  onBlur (e) {
    let updateState
    if (e.target.name === 'AccountingSystem' || e.target.name === 'AccountingSystem_KeyLoop') updateState = true
    this.props.saveInvoicingInformation(this.state.Invoicing).then((res) => {
      if (updateState) {
        this.setState({
          PNumberAccountingSystem: res.data.AccountingSystem
        })
        // Fetch token resources again to get updated data on invoicing system.
        this.props.getAuthResources()
      }
      // Toastr (replace dict. key)
      // window.toastr.success(translation('1724'), translation('13424'))

      this.getAccountingSystemField()
    }, () => {
      // Toastr (replace dict. key)
      window.toastr.error(translation('1725'), translation('216'))
    })
  }

  notConfirm () {
    this.setState({
      Confirm: {
        ...this.state.Confirm,
        Show: false
      }
    })
  }

  confirmDelete () {
    this.setState({
      Confirm: {
        ...this.state.Confirm,
        Show: false
      }
    })
    let key = this.state.Confirm.deleteKey
    let { DracarStores } = this.state
    let DracarCompanyStores = [ ...DracarStores.DracarCompanyStores ]
    DracarCompanyStores[key].IsDeleted = true
    DracarStores.DracarCompanyStores = DracarCompanyStores
    this.props.saveDracarStores(DracarStores).then(res => {
      this.setState({
        DracarStores: res.data
      })
    })
  }

  render () {
    let isWP = hasAccess([6], this.props.auth.user.UserType)
    if (isWP) {
      return (
        <div className='settings__screen'>
          <div className='settings__screen--inner clearfix'>
            {this.renderInvoicing()}
          </div>
        </div>
      )
    }
    return (this.renderInvoicing())
  }

  onAccountingSystemChange (e) {
    e.persist()
    let system = this.state.Invoicing.AccountingSystem
    let val = parseInt(e.target.value)
    if (val !== system) {
      this.setState({Invoicing: {...this.state.Invoicing, AccountingSystem: val}}, () => this.onBlur(e))
    }
  }

  getAccountingSystemName () {
    switch (this.state.Invoicing.AccountingSystem) {
      case 1:
        return translation('13489')
      case 2:
        return translation('13488')
      case 3:
        return translation('1382')
      case 4:
        return translation('15352')
      case 5:
        return translation('17942')
      case 6:
        return translation('18138')
      case 7:
        return translation('18235')// Visma.net
    }
  }

  renderAccountingRadios () {
    let isWP = hasAccess([6], this.props.auth.user.UserType)
    let dracarAllowed = this.props.auth.permissions.DracarAllowed
    let system = this.state.Invoicing.AccountingSystem
    // 15352 = 'Dracar+'

    return (
      <LabelWrapper labelText={13487}>
        <Radio id='AccountingSystem_none' name='AccountingSystem' value='0' onChange={this.onAccountingSystemChange} checked={system === 0} labelText={translation(433)} />
        <Radio id='AccountingSystem_economic' name='AccountingSystem' value='1' onChange={this.onAccountingSystemChange} checked={system === 1} labelText={translation(13489)} />
        {!isWP && <Radio id='AccountingSystem_helios' name='AccountingSystem' value='2' onChange={this.onAccountingSystemChange} checked={system === 2} labelText={translation(13488)} />}
        {!isWP && <Radio id='AccountingSystem_c5' name='AccountingSystem' value='3' onChange={this.onAccountingSystemChange} checked={system === 3} labelText={translation(1382)} />}
        {!isWP && dracarAllowed && <Radio id='AccountingSystem_KeyLoop' name='AccountingSystem' value='4' onChange={this.onAccountingSystemChange} checked={system === 4 || system === 6} labelText={18137} />}
        {!isWP && <Radio id='AccountingSystem_24SO' name='AccountingSystem' value='5' onChange={this.onAccountingSystemChange} checked={system === 5} labelText={translation(17942)} />}
        {!isWP && <Radio id='AccountingSystem_visma_net' name='AccountingSystem' value='7' onChange={this.onAccountingSystemChange} checked={system === 7} labelText={translation(18235)} />}
      </LabelWrapper>
    )
  }

  onFieldChange (e) {
    let name = e.target.name
    let value = e.target.value

    this.setState({[name]: value})
  }

  renderInvoicing () {
    const { DracarAllowed } = this.props.auth.permissions
    const { user } = this.props.auth
    let { Invoicing } = this.state
    let isWP = hasAccess([6], user.UserType)
    let accountingSystemName = this.getAccountingSystemName()
    let displayOnBodyShop = user.DepartmentType === DepartmentType.Body
    let displayOnPaintShop = user.DepartmentType === DepartmentType.Paint
    let displayOnWP = isWP
    let display = displayOnWP || displayOnPaintShop || displayOnBodyShop // display for all

    const invoiceFields = [
      {
        'id': 0,
        'key': 'OrderType',
        'translationKey': 525,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 1,
        'key': 'PickupDate',
        'translationKey': 18346,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 2,
        'key': 'DeliveryDate',
        'translationKey': 18347,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 3,
        'key': 'Chassinumber',
        'translationKey': 18348,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 4,
        'key': 'WarrantyCode',
        'translationKey': 13396,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 5,
        'key': 'DamageNumber',
        'translationKey': 18257,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 6,
        'key': 'ReportNumber',
        'translationKey': 18349,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 7,
        'key': 'RegistrationNumber',
        'translationKey': 2005,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 8,
        'key': 'BrandAndModel',
        'translationKey': 18350,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 9,
        'key': 'ApromasID',
        'translationKey': 18351,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 10,
        'key': 'RequisitionNumber',
        'translationKey': 80,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 11,
        'key': 'ExternalDeviations',
        'translationKey': 18352,
        'displayOnHeader': false,
        'display': displayOnPaintShop
      },
      {
        'id': 12,
        'key': 'AfterEvaluation',
        'translationKey': 1037,
        'displayOnHeader': false,
        'display': false
      },
      {
        'id': 13,
        'key': 'TotalWagesAndMaterialsOnIndividualLine',
        'translationKey': 18353,
        'displayOnHeader': false,
        'display': displayOnPaintShop
      },
      {
        'id': 14,
        'key': 'ColorCode',
        'translationKey': 79,
        'displayOnHeader': true,
        'display': display
      },
      {
        'id': 15,
        'key': 'WPDealerName',
        'translationKey': 18360,
        'displayOnHeader': true,
        'display': displayOnWP
      }
    ]

    const positions = [
      {
        'id': 0,
        'key': 'HeadlineFields'
      },
      {
        'id': 1,
        'key': 'Text1Fields'
      },
      {
        'id': 2,
        'key': 'Text2Fields'
      },
      {
        'id': 3,
        'key': 'OtherReferencesFields'
      },
      {
        'id': 4,
        'key': 'ReferenceFields'
      },
      {
        'id': 5,
        'key': 'InvoiceTextFields'
      },
      {
        'id': 6,
        'key': 'CustomerOrderIdFields'
      },
      {
        'id': 7,
        'key': 'ExternalReferenceFields'
      },
      {
        'id': 8,
        'key': 'ExtraLinesFields'
      },
      {
        'id': 9,
        'key': 'CommentFields'
      }
    ]

    const renderInvoiceHeaderField = (field) => {
      if (field.displayOnHeader && field.display) {
        return (
          <option key={field.id} value={field.id}>{translation(field.translationKey)}</option>
        )
      }
    }

    const renderExtraInvoiceLineField = (field) => {
      if (field.display) {
        return (
          <option key={field.id} value={field.id}>{translation(field.translationKey)}</option>
        )
      }
    }

    const addInvoiceField = (position, dataItem) => {
      let key = positions[position].key
      if (dataItem === undefined || dataItem === -1) {
        window.toastr.error('please choose an item from the drop-down')
      } else if (this.state[key].some(item => item.DataItem === dataItem)) {
        window.toastr.error('unable to add a field twice')
      } else {
        let data = {
          Position: position,
          DataItem: dataItem
        }
        this.props.updateAccountingSystemField(data).then((res) => {
          let field = {
            Id: res.data.Id,
            Position: position,
            DataItem: dataItem
          }
          this.setState({[key]: [...this.state[key], field]})
        }, () => {
          window.toastr.error(translation('1725'), translation('216'))
        })
      }
    }

    const renderSelectedField = (val, key) => {
      return (
        <Inline fillChildNum={[0]} block key={key}>
          <Label>{translation(invoiceFields[val.DataItem].translationKey)}</Label>
          <RemoveButton onClick={() => removeInvoiceField(val)} id={val.Id} size='s' />
        </Inline>
      )
    }

    const removeInvoiceField = (field) => {
      let key = positions[field.Position].key
      let fields = [...this.state[key]]
      let index = fields.map(item => item.Id).indexOf(field.Id)
      if (index !== -1) {
        this.props.deleteAccountingSystemField(field.Id).then((res) => {
          fields.splice(index, 1)
          this.setState({[key]: fields})
        }, () => {
          window.toastr.error(translation('1725'), translation('216'))
        })
      }
    }

    return (
      <div className='invoicing__page'>
        <Row>
          <Col>
            <Panel title={translation('13486')}>
              {this.renderAccountingRadios()}

              {this.state.Invoicing.IsPaintshop && (
                <LabelWrapper labelText={translation('16527')}>
                  <Radio name='TransferWorkHoursAsUnitPrice' value={'no'} onChange={this.onChange} checked={!Invoicing.TransferWorkHoursAsUnitPrice} labelText={translation('16528')} />
                  <Radio name='TransferWorkHoursAsUnitPrice' value={'yes'} onChange={this.onChange} checked={Invoicing.TransferWorkHoursAsUnitPrice} labelText={translation('16529')} />
                </LabelWrapper>
              )}
            </Panel>
            {Invoicing.AccountingSystem === 1 && (
            <Panel title={translation('16672')}>
              <Switch name='EconomicUseCustomDepartment' onChange={this.onChange} checked={Invoicing.EconomicDepartment === -1} labelText={translation('15321')} />
              {Invoicing.EconomicDepartment !== -1 && [
                <Radio key='EconomicDepartment_0' id='EconomicDepartment_PersonCars' name='EconomicDepartment' value='0' onChange={this.onChange} checked={Invoicing.EconomicDepartment === 0} labelText='100' />,
                !isWP && <Radio key='EconomicDepartment_1' id='EconomicDepartment_BigCars' name='EconomicDepartment' value='1' onChange={this.onChange} checked={Invoicing.EconomicDepartment === 1} labelText='200' />,
                !isWP && <Radio key='EconomicDepartment_2' id='EconomicDepartment_Industry' name='EconomicDepartment' value='2' onChange={this.onChange} checked={Invoicing.EconomicDepartment === 2} labelText='300' disabled={isWP} />]}
              {Invoicing.EconomicDepartment === -1 && (
                <Text name='EconomicDepartmentType' value={Invoicing.EconomicDepartmentType} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('15202')} />
              )}
            </Panel>)}
            {Invoicing.AccountingSystem === 7 && (
            <Panel title={translation('16672')}>
              <Switch name='VismaNetUseCustomDepartment' onChange={this.onChange} checked={Invoicing.VismaNetDepartment === -1} labelText={translation('15321')} />
              {Invoicing.VismaNetDepartment !== -1 && [
                <Radio key='VismaNetDepartment_0' id='VismaNetDepartment_PersonCars' name='VismaNetDepartment' value='0' onChange={this.onChange} checked={Invoicing.VismaNetDepartment === 0} labelText='100' />,
                !isWP && <Radio key='VismaNetDepartment_1' id='VismaNetDepartment_BigCars' name='VismaNetDepartment' value='1' onChange={this.onChange} checked={Invoicing.VismaNetDepartment === 1} labelText='200' />,
                !isWP && <Radio key='VismaNetDepartment_2' id='VismaNetDepartment_Industry' name='VismaNetDepartment' value='2' onChange={this.onChange} checked={Invoicing.VismaNetDepartment === 2} labelText='300' disabled={isWP} />]}
              {Invoicing.VismaNetDepartment === -1 && (
                <Text name='VismaNetDepartmentType' value={Invoicing.VismaNetDepartmentType} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('15202')} />
              )}
            </Panel>)}
          </Col>
          {Invoicing.AccountingSystem !== 0 && (
            <Col>
              <Panel title={accountingSystemName}>
                {Invoicing.AccountingSystem === 2 && (
                  <Text name='HeliosNumber' value={Invoicing.HeliosNumber || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('499')} />
                )}

                {Invoicing.AccountingSystem === 1 && (
                  <div>
                    <Text name='EconomicId' value={Invoicing.EconomicId} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('1132')} />
                    <Text name='EconomicUserName' value={Invoicing.EconomicUserName || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('13490')} />
                    <Text name='EconomicPassword' value={Invoicing.EconomicPassword || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('13491')} />

                    <Null comment='Hint link for EconomicToken'><a className='token_link' href={Invoicing.EconomicAuthUrl}><img src='/images/icons/Cirkle_info-grey25x25px.png' /></a></Null>
                    <Text name='EconomicToken' value={Invoicing.EconomicToken} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('13017')} helpText={<a className='token_link' href={Invoicing.EconomicAuthUrl}>Economic</a>} />

                    <Text name='EconomicWebHook' value={Invoicing.EconomicWebHook} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('13493')} />
                  </div>
                )}
                {Invoicing.AccountingSystem === 7 && (
                  <div>
                    <Null comment='Hint link for VismaNetToken'><a className='token_link' href={Invoicing.VismaNetAuthUrl}><img src='/images/icons/Cirkle_info-grey25x25px.png' /></a></Null>
                    <Text name='VismaNetToken' value={Invoicing.VismaNetToken} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('18239')} helpText={<a className='token_link' href={Invoicing.VismaNetAuthUrl}>{translation(18235)}</a>} />
                  </div>
                )}

                {Invoicing.AccountingSystem === 3 && (
                  <Text name='C5Ftp' value={Invoicing.C5Ftp || ''} onChange={this.onChange} onBlur={this.onBlur} disabled labelText={translation('556')} />
                )}
                {[4, 6].includes(Invoicing.AccountingSystem) && DracarAllowed && (
                  <div>
                    <LabelWrapper labelText={translation('18137')} spacing={4}>
                      <Radio name='AccountingSystem_KeyLoop' value={'4'} onChange={this.onAccountingSystemChange} checked={Invoicing.AccountingSystem === 4} labelText={translation(15352)} />
                      <Radio name='AccountingSystem_KeyLoop' value={'6'} onChange={this.onAccountingSystemChange} checked={Invoicing.AccountingSystem === 6} labelText={translation(18138)} />
                    </LabelWrapper>

                    <Switch name='DracarInvoiceLaborTotal' onChange={this.onChange} checked={Invoicing.DracarInvoiceLaborTotal} labelText={translation('17838')} />
                    <Switch name='DracarInvoiceUnitsTotal' onChange={this.onChange} checked={Invoicing.DracarInvoiceUnitsTotal} labelText={translation('17927')} />
                    {Invoicing.DracarInvoiceLaborTotal && Invoicing.AccountingSystem === 4 && (
                      <Text name='DracarInvoiceLaborTotalCode' value={Invoicing.DracarInvoiceLaborTotalCode || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('17839')} />
                    )}
                    <LabelWrapper labelText={translation('17867')}>
                      <Radio name='UseDracarSparePartCreation' value={'no'} onChange={this.onChange} checked={!Invoicing.UseDracarSparePartCreation} labelText={translation(DICT_HANDLED_IN_APROMAS)} />
                      {Invoicing.AccountingSystem === 4 && <Radio name='UseDracarSparePartCreation' value={'yes'} onChange={this.onChange} checked={Invoicing.UseDracarSparePartCreation} labelText={translation(DICT_HANDLED_IN_DRACAR)} />}
                      {Invoicing.AccountingSystem === 6 && <Radio name='UseDracarSparePartCreation' value={'yes'} onChange={this.onChange} checked={Invoicing.UseDracarSparePartCreation} labelText={translation(DICT_HANDLED_IN_AUTOLINE)} />}
                    </LabelWrapper>
                    <LabelWrapper labelText={translation(17943).replace('[KeyLoopSystem]', accountingSystemName)}>
                      <Radio id='InsuranceCompanyTypeInDracar_Customer' name='InsuranceCompanyTypeInDracar' value='1' onChange={this.onChange} checked={Invoicing.InsuranceCompanyTypeInDracar === 1} labelText={translation('17944')} />
                      <Radio id='InsuranceCompanyTypeInDracar_Company' name='InsuranceCompanyTypeInDracar' value='0' onChange={this.onChange} checked={Invoicing.InsuranceCompanyTypeInDracar === 0} labelText={translation('17945')} />
                    </LabelWrapper>
                  </div>
                )}

                {Invoicing.AccountingSystem === 5 && (
                  <div>
                    <Text name='TFSOUserName' value={Invoicing.TFSOUserName || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('17940')} />
                    <Text name='TFSOPassword' value={Invoicing.TFSOPassword || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('17941')} />
                    <Text name='TFSODepartmentNumber' value={Invoicing.TFSODepartmentNumber || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('17946')} />
                  </div>
                )}
              </Panel>
            </Col>
          )}
          {/* display on E-conomic */}
          {Invoicing.AccountingSystem === 1 && (
            <Col>
              <Panel title={translation('18344')}>
                <LabelWrapper labelText={1229} spacing={4}>
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='SelectedHeadlineField' onChange={this.onFieldChange} value={this.state.SelectedHeadlineField}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderInvoiceHeaderField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(0, this.state.SelectedHeadlineField)} />
                  </Grid>
                  <br />
                  {this.state.HeadlineFields !== null && this.state.HeadlineFields.map(renderSelectedField)}
                </LabelWrapper>
                <LabelWrapper labelText={18354} spacing={4}>
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='SelectedText1Field' onChange={this.onFieldChange} value={this.state.SelectedText1Field}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderInvoiceHeaderField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(1, this.state.SelectedText1Field)} />
                  </Grid>
                  <br />
                  {this.state.Text1Fields !== null && this.state.Text1Fields.map(renderSelectedField)}
                </LabelWrapper>
                <LabelWrapper labelText={18355} spacing={4}>
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='SelectedText2Field' onChange={this.onFieldChange} value={this.state.SelectedText2Field}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderInvoiceHeaderField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(2, this.state.SelectedText2Field)} />
                  </Grid>
                  <br />
                  {this.state.Text2Fields !== null && this.state.Text2Fields.map(renderSelectedField)}
                </LabelWrapper>
                <LabelWrapper labelText={18356} >
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='SelectedOtherReferencesField' onChange={this.onFieldChange} value={this.state.SelectedOtherReferencesField}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderInvoiceHeaderField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(3, this.state.SelectedOtherReferencesField)} />
                  </Grid>
                  <br />
                  {this.state.OtherReferencesFields !== null && this.state.OtherReferencesFields.map(renderSelectedField)}
                </LabelWrapper>
              </Panel>
            </Col>
          )}
          {/* display on 24SevenOffice */}
          {Invoicing.AccountingSystem === 5 && (
            <Col>
              <Panel title={translation('18344')}>
                <LabelWrapper labelText={18357} spacing={4}>
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='SelectedReferenceField' onChange={this.onFieldChange} value={this.state.SelectedReferenceField}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderInvoiceHeaderField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(4, this.state.SelectedReferenceField)} />
                  </Grid>
                  <br />
                  {this.state.ReferenceFields !== null && this.state.ReferenceFields.map(renderSelectedField)}
                </LabelWrapper>
                <LabelWrapper labelText={1219} spacing={4}>
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='SelectedInvoiceTextField' onChange={this.onFieldChange} value={this.state.SelectedInvoiceTextField}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderInvoiceHeaderField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(5, this.state.SelectedInvoiceTextField)} />
                  </Grid>
                  <br />
                  {this.state.InvoiceTextFields !== null && this.state.InvoiceTextFields.map(renderSelectedField)}
                </LabelWrapper>
                <LabelWrapper labelText={149} >
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='SelectedCommentField' onChange={this.onFieldChange} value={this.state.SelectedCommentField}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderInvoiceHeaderField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(9, this.state.SelectedCommentField)} />
                  </Grid>
                  <br />
                  {this.state.CommentFields !== null && this.state.CommentFields.map(renderSelectedField)}
                </LabelWrapper>
              </Panel>
            </Col>
          )}
          {/* display on Visma.net */}
          {Invoicing.AccountingSystem === 7 && (
            <Col>
              <Panel title={translation('18344')}>
                <LabelWrapper labelText={18358} spacing={4}>
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='SelectedCustomerOrderIdField' onChange={this.onFieldChange} value={this.state.SelectedCustomerOrderIdField}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderInvoiceHeaderField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(6, this.state.SelectedCustomerOrderIdField)} />
                  </Grid>
                  <br />
                  {this.state.CustomerOrderIdFields !== null && this.state.CustomerOrderIdFields.map(renderSelectedField)}
                </LabelWrapper>
                <LabelWrapper labelText={18359} spacing={4}>
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='SelectedExternalReferenceField' onChange={this.onFieldChange} value={this.state.SelectedExternalReferenceField}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderInvoiceHeaderField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(7, this.state.SelectedExternalReferenceField)} />
                  </Grid>
                  <br />
                  {this.state.ExternalReferenceFields !== null && this.state.ExternalReferenceFields.map(renderSelectedField)}
                </LabelWrapper>
                <LabelWrapper labelText={1219} >
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='SelectedInvoiceTextField' onChange={this.onFieldChange} value={this.state.SelectedInvoiceTextField}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderInvoiceHeaderField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(5, this.state.SelectedInvoiceTextField)} />
                  </Grid>
                  <br />
                  {this.state.InvoiceTextFields !== null && this.state.InvoiceTextFields.map(renderSelectedField)}
                </LabelWrapper>
              </Panel>
            </Col>
          )}
          {/* Display for all systems */}
          {Invoicing.AccountingSystem !== 0 && (
            <Col>
              <Panel title={translation('18345')}>
                <LabelWrapper labelText={18345} spacing={0}>
                  <Grid cols={['200px', 'auto']}>
                    <DropDown name='selectedExtraLinesField' onChange={this.onFieldChange} value={this.state.selectedExtraLinesField}>
                      <option value={-1}>{translation('890')}</option>
                      {invoiceFields.map(renderExtraInvoiceLineField)}
                    </DropDown>
                    <AddButton onClick={() => addInvoiceField(8, this.state.selectedExtraLinesField)} />
                  </Grid>
                  <br />
                  {this.state.ExtraLinesFields !== null && this.state.ExtraLinesFields.map(renderSelectedField)}
                </LabelWrapper>
              </Panel>
            </Col>
          )}
        </Row>
        {!isWP && Invoicing.AccountingSystem > 0 && !([4, 6].includes(Invoicing.AccountingSystem) && DracarAllowed) && hasSubscriptionPermission(this.props.auth, 10) && (
          <ProductNumbers section='report' accountingSystem={this.state.PNumberAccountingSystem} />
        )}
        {!isWP && Invoicing.AccountingSystem > 0 && !([4, 6].includes(Invoicing.AccountingSystem) && DracarAllowed) && hasSubscriptionPermission(this.props.auth, 10) && (
          <ProductNumbers section='other' accountingSystem={this.state.PNumberAccountingSystem} />
        )}
        {[4, 6].includes(Invoicing.AccountingSystem) && DracarAllowed && this.renderDracarJobFeeSettings()}
        {[4, 6].includes(Invoicing.AccountingSystem) && DracarAllowed && this.renderDracarStores()}
        {this.state.Confirm.Show === true && (
          <Portal className='confirm_popup' onPortalClose={this.notConfirm}>
            <Confirm t={translation} renderText={() => translation(16760)} confirm={this.confirmDelete} notConfirm={this.notConfirm} />
          </Portal>
        )}
      </div>
    )
  }

  renderDracarStores () {
    let { DracarStores } = this.state

    const renderNew = () => {
      let { DracarStoreNew } = this.state
      const addItem = () => {
        let DracarCompanyStores = [ ...DracarStores.DracarCompanyStores ]
        DracarCompanyStores.push(this.state.DracarStoreNew)
        DracarStores.DracarCompanyStores = DracarCompanyStores
        this.props.saveDracarStores(DracarStores).then(res => {
          this.setState({
            DracarStores: res.data,
            DracarStoreNew: {
              StoreName: '',
              StoreId: '',
              EnterpriseId: '',
              IsDeleted: false
            }
          })
        })
      }

      // Store id = 18140
      // enterprise id = 18141

      let systemText = this.getAccountingSystemName()
      // switch (this.state.Invoicing.AccountingSystem) {
      //   case 4:
      //     systemText = translation(DICT_DRACAR_PLUS)
      //     break
      //   case 6:
      //     systemText = translation(DICT_AUTOLINE)
      //     break
      // }
      const storeIdText = systemText + ' ' + translation(18140)
      const enterpriseIdText = systemText + ' ' + translation(18141)
      return (

        <Grid cols={[1, 1, 1, 'min-content']} align='center'>
          <Text labelText={16759} name='DracarStoreStoreName' value={DracarStoreNew.StoreName} onChange={this.onChange} />
          <Text labelText={storeIdText} name='DracarStoreStoreId' value={DracarStoreNew.StoreId} onChange={this.onChange} />
          <Text labelText={enterpriseIdText} name='DracarStoreEnterpriseId' value={DracarStoreNew.EnterpriseId} onChange={this.onChange} />
          <AddButton onClick={addItem} />
        </Grid>
      )
    }

    const renderStores = (val, key) => {
      const deleteItem = (key) => {
        this.setState({
          Confirm: {
            deleteKey: key,
            Show: true
          }
        })
      }
      return (
        <Grid cols={[1, 1, 1, 'min-content']} key={key} spacing={1}>
          <Label>{val.StoreName}</Label>
          <Label>{val.StoreId}</Label>
          <Label>{val.EnterpriseId}</Label>
          <RemoveButton size='m' onClick={deleteItem.bind(this, key)} />
        </Grid>
      )
    }

    return (
      <Col span={3}>
        <Panel title={translation(16758).replace('[KeyLoopSystem]', this.getAccountingSystemName())}>
          {renderNew()}
          {DracarStores.DracarCompanyStores.length > 0 && DracarStores.DracarCompanyStores.map(renderStores)}
        </Panel>
      </Col>
    )
  }

  renderDracarJobFeeSettings () {
    let { DracarJobFeeSettings } = this.state.Invoicing
    const renderJobFeeSettings = (val, key) => {
      let labelText = ''
      switch (val.DType) {
        case DracarJobFeeSettingType.LABOR_1:
          labelText = translation('416')
          break
        case DracarJobFeeSettingType.BODYSHOP_ENVIRONMENT_2:
          labelText = translation('15156')
          break
        case DracarJobFeeSettingType.SUNDRYPARTS_MATERIAL_3:
          labelText = translation('14785')
          break
        case DracarJobFeeSettingType.SUNDRYPARTS_TOTAL_4:
          labelText = translation('16755')
          break
        case DracarJobFeeSettingType.HOLLOW_CAVITY_SEALANT_5:
          labelText = translation('16756')
          break
        case DracarJobFeeSettingType.PAINT_6:
          labelText = translation('161')
          break
        case DracarJobFeeSettingType.PAINT_ENVIRONMENT_7:
          labelText = translation('15155')
          break
        case DracarJobFeeSettingType.DIFFERENCE_INSURANCE_8:
          labelText = translation('15154')
          break
        case DracarJobFeeSettingType.AUTOLINE_CONSUMABLES_9:
          labelText = translation('18139')
          break
        default:
          break
      }
      return (
        <Grid spacing='1' align='center' cols={[2, 1]} key={'dnum_' + key}>
          <span>{labelText}</span>
          <Text size='m' name={'DType' + val.DType} value={val.DNumber} onChange={this.onChange} onBlur={this.onBlur} />
        </Grid>
      )
    }

    return (
      <Row>
        <Col span={2}>
          <Panel title={translation('15295')}>
            {DracarJobFeeSettings.map(renderJobFeeSettings)}
          </Panel>
        </Col>
      </Row>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getInvoicingInformation,
  saveInvoicingInformation,
  getDracarStores,
  saveDracarStores,
  getAuthResources,
  getAccountingSystemField,
  deleteAccountingSystemField,
  updateAccountingSystemField
})(Invoicing)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/Invoicing/index.js